module.exports = __webpack_public_path__ + "static/hero-butler-text-5038b93866219c94afc8ef38378eb26e.jpg";